// extracted by mini-css-extract-plugin
module.exports = {"sportTitle":"SportTitle_sportTitle__VpTCm","sportIcon":"SportTitle_sportIcon___biY_","sportName":"SportTitle_sportName__2Zi9C","eventCount":"SportTitle_eventCount__3uTm8"};